import useOutletTransition from '@/hooks/useOutletTransition';
import StatisticsPage from './index';
import BottomNavigation from '@/components/common/BottomNavigation';

// 통계 탭 WithOutlet 래퍼 (네이티브 푸시 트랜지션)
export default function StatisticsWithOutlet() {
  const {
    hasOutlet,
    displayOutlet,
    isExiting,
    isSettled,
    showOverlay,
    skipAnimation,
    transitionMs,
  } = useOutletTransition();

  const parentShifted = hasOutlet && !isSettled;

  return (
    <>
      <div
        className="w-full flex-1 flex flex-col overflow-hidden"
        style={{
          transform: parentShifted ? 'translateX(-30%)' : 'translateX(0)',
          transition: isSettled
            ? 'none'
            : `transform ${transitionMs}ms ease-out`,
        }}
      >
        <StatisticsPage />
      </div>
      <BottomNavigation />
      {showOverlay && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1200,
            backgroundColor: '#FFFFFF',
            animation: skipAnimation
              ? 'none'
              : `${isExiting ? 'slideOutToRight' : 'slideInFromRight'} ${transitionMs}ms ease-out forwards`,
          }}
        >
          {displayOutlet}
        </div>
      )}
    </>
  );
}
